export default function getResource(label) {
    const resources = {
        compareProducts: 'Comparer les articles',
        emptySlot: 'Vide',
        colors: 'Couleurs',
        color: 'Color',
        sizes: 'Formats',
        size: 'size',
        standardSize: 'Standard size: ',
        ratingsAndReviews: 'Évaluations et commentaires',
        prosMentioned: 'Pros Mentioned',
        consMentioned: 'Cons Mentioned',
        overview: 'Aperçu',
        ingredients: 'Ingrédients',
        pickupAndDelivery: 'Ramassage et livraison'
    };

    return resources[label];
}
